import React from "react";
import { loadCaptchaEnginge, LoadCanvasTemplate } from "react-simple-captcha";
import { Row, Col } from "antd";

const CAPTCH_FONT_COLOR = "rgba(49, 65, 134, 1)";
const CAPTCH_BACKGROUND_COLOR = "white";

const Captcha = () => {
    React.useEffect(() => {
        loadCaptchaEnginge(6, CAPTCH_BACKGROUND_COLOR, CAPTCH_FONT_COLOR);
    }, []);

    return (
        <Row
            justify="center"
            align="middle"
            style={{
                border: "1px solid #D1D1FF",
                marginTop: "5px",
                paddingTop: "7px",
                borderRadius: "4px",
                backgroundColor: "white",
            }}
        >
            <Col>
                <LoadCanvasTemplate />
            </Col>
        </Row>
    );
};

export default Captcha;
